var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-12"},[_vm._v("result: "+_vm._s(_vm.result))]),_c('div',{staticClass:"col col-12"},[_c('div',{staticClass:"btn btn-primary",on:{"click":_vm.CloseModal}},[_vm._v("Close")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }